import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoPipe } from '@jsverse/transloco';
import { FormatNumberPipe } from '@web/birdz-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { KpiType } from 'app/types/kpi-type.type';
export interface CellKpiNumberParams extends ICellRendererParams {
  kpiType: KpiType;
  kpiValue: number;
  // set when the cell opens a history chart on click: hint displayed on the whole cell
  historyHint?: { key: string; params?: Record<string, unknown> };
}

@Component({
  selector: 'app-cell-kpi-number',
  imports: [MatTooltip, MatIconModule, FormatNumberPipe, TranslocoPipe],
  templateUrl: './cell-kpi-number.component.html',
  styleUrl: './cell-kpi-number.component.scss',
})
export class CellKpiNumberComponent {
  value = 0;
  format = '1.0-0';
  unit = '';
  hasExclusion = false;
  historyHint: CellKpiNumberParams['historyHint'] = undefined;

  constructor() {}

  agInit(params: CellKpiNumberParams) {
    this.historyHint = params.historyHint;
    if (params.kpiType === 'RATIO') {
      this.value = params.kpiValue * 100;
      this.format = '1.2-2';
      this.unit = '%';
    } else {
      this.value = params.kpiValue;
      this.format = '1.0-0';
      this.unit = '';
      if (params.data.motif_exclu != null && params.data.motif_exclu.length > 0) {
        this.hasExclusion = true;
      }
    }
  }

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
}
